module.exports = __webpack_public_path__ + "static/the-end-of-your-life-book-club-7417f26bbece25a54fd96895b78cb23f.jpg";